import React from 'react';
import TeamContent from '../../FunctionalComponents/Team/TeamContent';

const Team = () => {
  return (
    <TeamContent />
  )
}

export default Team;